const config = {
  sources: {
    current: `${ARTICLE_CONFIG.baseUrl}/data/corona/current.v4.csv`,
    history: `${ARTICLE_CONFIG.baseUrl}/data/corona/history.compact.json`,
    heatmap: `${ARTICLE_CONFIG.baseUrl}/data/corona/cases.rki.v2.csv`,
    reproduction: `${ARTICLE_CONFIG.baseUrl}/data/corona/reproduction.rki.csv`,
    ampel: `${ARTICLE_CONFIG.baseUrl}/data/corona/ampel.csv`,
    totals_v1: `${ARTICLE_CONFIG.baseUrl}/data/corona/totals.csv`,
    totals_v2: `${ARTICLE_CONFIG.baseUrl}/data/corona/totals.v2.csv`,
  },
  sliderMinDate: new Date(2020, 0, 27).getTime(),
  areaChartMinDate: new Date(2020, 0, 22).getTime(),
  trend: {
    zeroBoundMin: -1, // untere Grenze für gleichbleibenden Trend, in Prozent
    zeroBoundMax: 1, // obere Grenze für gleichbleibenden Trend, in Prozent
    fullRotationMin: -50, // untere Grenze für voll ausgeschlagenen Pfeil, in Prozent
    fullRotationMax: 50, // obere Grenze für voll ausgeschlagenen Pfeil, in Prozent
    zeroThreshold: 3, // wenn in einer Woche max. so viele Fälle, dann wird Punkt angezeigt
  },
  map: {
    bounds: {
      desktop: {
        germany: [
          [46.872397, 5.761471],
          [55.339299, 15.077877],
        ],
        europe: [
          [41.508577, -16.523438],
          [65.366837, 37.617188],
        ],
        world: [
          [-34.442592, -129.289856],
          [69.415347, 148.268738],
        ],
      },
      mobile: {
        germany: [
          [46.863008, 5.258331],
          [55.926894, 15.805206],
        ],
        europe: [
          [41.19674, -17.628937],
          [68.697253, 40.906219],
        ],
        world: [
          [-23.828064, -42.456665],
          [75.687822, 149.49646],
        ],
      },
    },
    minZoom: 1.5,
    maxZoom: 9,
    minRadius: 3000,
    maxRadius: 300000,
    attribution:
      '<a href="https://leafletjs.com/" target="_blank" rel="noreferrer">Leaflet</a> | <a href="https://openmaptiles.org/" target="_blank" rel="noreferrer">© OpenMapTiles</a> <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">© OpenStreetMap contributors</a>',
    //attribution: '<strong>Datenquellen:</strong> RKI, JHU uvm. (<strong>siehe unten</strong>)',
    basemap: `${ARTICLE_CONFIG.baseUrl}/maps/corona/{z}/{x}/{y}@2x.jpg`,
  },
  europeIds: [
    'al',
    'ad',
    'at',
    'ad',
    'ba',
    'be',
    'bg',
    'by',
    'ch',
    'cy',
    'cz',
    'de',
    'dk',
    'ee',
    'es',
    'fi',
    'fo',
    'fr',
    'gg',
    'gg+je',
    'gi',
    'gr',
    'hr',
    'hu',
    'ie',
    'is',
    'it',
    'je',
    'li',
    'lt',
    'lu',
    'lv',
    'mc',
    'md',
    'me',
    'mk',
    'mt',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'rs',
    'ru',
    'se',
    'si',
    'sk',
    'sm',
    'tr',
    'ua',
    'uk',
    'va',
    'xk',
  ],
  noRecoveredIds: ['nl', 'uk', 'se', 'rs', 'pr'],
};

export default config;
